import React, { useState, useEffect } from "react";
import {
  useGetAssignedComplianceListQuery,
  useGetAdminComplianceListQuery,
  useAssignTemplateMutation,
} from "../../../appRedux/api/complianceApi";
import { useGetPartnerListQuery } from "../../../appRedux/api/adminPartnerApi";
import { showConfirm, getRole } from "../../../helpers";
import { useSelector } from "react-redux";
import { Form, Row, Col, Button, Card, Spin, message } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { Select } from "antd";
import { useNavigate } from "react-router-dom";
import './style.css'
const { Option } = Select;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

const AssignComplianceTemplate = (props) => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Use the RTK query hook with list parameter
  const { data: partnersList, isLoading: partnersLoading } = useGetPartnerListQuery({ list: true });
  const { data: adminComplianceList, isLoading: complianceLoading } =
    useGetAdminComplianceListQuery();
  const [selectedPartnerId, setSelectedPartnerId] = useState("");
  const { data: assignedComplianceList, isLoading: assignedLoading } =
    useGetAssignedComplianceListQuery(selectedPartnerId, {
      skip: !selectedPartnerId,
    });
  const [assignTemplate] = useAssignTemplateMutation();

  const [isUserAdmin, setIsUserAdmin] = useState(false);
  const [data, setData] = useState([]);
  const [admincomplianceListData, setadmincomplianceListData] = useState([]);
  const [assignedComplianceData, SetassignedComplianceData] = useState([]);
  const [assignedPartnerComliance, setassignedPartnerCompliance] = useState([]);

  useEffect(() => {
    setIsUserAdmin(() => {
      return getRole() === "ADMIN";
    });
  }, []);

  useEffect(() => {
    if (partnersList?.results) {
      // Transform the API response to match the expected format
      let rowData = partnersList.results
        .filter(item => item.partner) // Ensure partner data exists
        .map(item => ({
          key: item.partner.partner_id, // Use partner_id from the nested partner object
          name: item.partner.company_name // Use company_name from the nested partner object
        }));
      setData(rowData);
    }
  }, [partnersList]);

  useEffect(() => {
    const prefilledTemplates = [];
    assignedComplianceData.map((value) =>
      prefilledTemplates.push(value.c_id),
    );
    setassignedPartnerCompliance(prefilledTemplates);
  }, [selectedPartnerId]);

  useEffect(() => {
    if (adminComplianceList) {
      let complianceData = adminComplianceList.length
        ? adminComplianceList.map((value) => ({
            c_id: value.template_id,
            t_name: value.template_name,
          }))
        : [];
      setadmincomplianceListData(complianceData);
    }
  }, [adminComplianceList]);

  const getFinalAssignedComplianceList = (assignedComplianceArray) => {
    let data = [];
    assignedComplianceArray.forEach((val) => {
      if (val.assign_templates && val.assign_templates.length > 0) {
        for (let i = 0; i < val.assign_templates.length; i++) {
          data.push({
            c_id: val.template_id,
            t_name: val.template_name,
          });
        }
      } else {
        data.push({
          c_id: val.template_id,
          t_name: val.template_name,
        });
      }
    });
    return data;
  };

  useEffect(() => {
    if (assignedComplianceList) {
      let complianceData = assignedComplianceList.partner_templates;
      let filteredcomplianceData = complianceData
        ? complianceData.assign_templates
        : [];
      const finalAssisgnedComplianceData = getFinalAssignedComplianceList(
        filteredcomplianceData,
      );

      SetassignedComplianceData(finalAssisgnedComplianceData);
    }
  }, [assignedComplianceList]);

  const [form] = Form.useForm();

  const onFinish = async (values) => {
    setIsSubmitting(true);
    try {
      const template_id_data = [];
      var ele;
      for (ele in values.compliance_letter) {
        template_id_data.push({
          template_id: values.compliance_letter[ele],
        });
      }
      const submitData = {
        partner_id: values.partner_list,
        templates: template_id_data,
      };

      await assignTemplate(submitData).unwrap();
      message.success('Template assigned successfully');
      navigateBack();
    } catch (err) {
      message.error(err.data?.message || 'Failed to assign template');
    } finally {
      setIsSubmitting(false);
    }
  };

  const navigateBack = () => {
    navigate(-1);
  };

  const navigateToComplianceList = () => {
    navigate("/admin/partner-compliance");
  };

  const getAssignedCompliance = (value) => {
    setSelectedPartnerId(value);
  };

  const handleChange = (value) => {
    console.log("FieldValue :", value);
  };

  const options_data = (data) => {
    return data.map((user) => ({ 
      value: user.key, 
      label: user.name 
    }));
  };

  useEffect(() => {
    if (assignedComplianceList && assignedComplianceList.partner_templates) {
      form.setFieldsValue({
        compliance_letter:
          assignedComplianceList.partner_templates.assign_templates.map(
            (val) => val.template_id,
          ),
      });
    } else if (selectedPartnerId && !assignedLoading) {
      form.setFieldsValue({
        compliance_letter: [],
      });
    }
  }, [assignedComplianceList, assignedLoading, form, selectedPartnerId]);

  return (
    <div>
      <Spin spinning={isSubmitting}>
        <Row>
          <Col span={24}>
            <h1 className="title gx-mb-4">
              <LeftOutlined className="mr-5" onClick={navigateBack} />
              Assign Template
            </h1>
          </Col>
          <Col span={24}>
            <Card className="gx-card compliance-template-card-ui">
              <Row>
                <Col span={22}>
                  <Form
                    {...formItemLayout}
                    form={form}
                    name="add-template"
                    onFinish={onFinish}
                    scrollToFirstError
                  >
                    <Form.Item name="partner_list" label="Partner">
                      <Select
                        showSearch
                        onChange={getAssignedCompliance}
                        loading={partnersLoading}
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        options={options_data(data)}
                        placeholder="Select a partner"
                        notFoundContent={partnersLoading ? "Loading..." : "No partners found"}
                      />
                    </Form.Item>

                    <Form.Item name="compliance_letter" label="Assigned">
                      <Select
                        mode="multiple"
                        showSearch={false}
                        allowClear
                        placeholder="Please select"
                      >
                        {admincomplianceListData.map((letter) => (
                          <Option key={letter.c_id}>{letter.t_name}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item className="flex-d-column">
                      <Button
                        id="add-product-submit"
                        type="primary"
                        htmlType="submit"
                        loading={isSubmitting}
                      >
                        Submit
                      </Button>
                      <Button
                        id="add-product-cancel"
                        onClick={navigateToComplianceList}
                        disabled={isSubmitting}
                      >
                        Cancel
                      </Button>
                    </Form.Item>
                  </Form>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Spin>
    </div>
  );
};
export default AssignComplianceTemplate;